module.exports = __webpack_public_path__ + "assets/a20bfc02e87f9cf8e2c2cec7bca8ea32.png";